import api from "../../../utils/api";
import type { FirestoreTimestamp } from "./leadsService";

// ============================================================================
// CRM Activities — frontend service. Reads the account activity timeline that
// the torre-de-control-api builds from CRM Firestore triggers.
//   • list (authed): GET /crm/activitiesList
// Activities are append-only and written server-side; the console only reads.
// ============================================================================

/** `meeting` (#1308): reunión con un prospecto que ya cuenta en Horas Trabajadas. */
export type ActivityType = "lead" | "call" | "pipeline" | "meeting" | "other";

export interface Activity {
  id: string;
  type: ActivityType;
  action: string | null;
  description: string;
  actor: string | null;
  entityType: "lead" | "call" | null;
  entityId: string | null;
  entityName: string | null;
  leadId: string | null;
  callId: string | null;
  meta?: Record<string, unknown>;
  createdAt?: FirestoreTimestamp | string | null;
}

export interface ActivitiesPage {
  data: Activity[];
  totalItems: number;
  totalPages: number;
  currentPage: number;
}

interface ActivitiesListParams {
  page?: number;
  limit?: number;
  type?: ActivityType;
  leadId?: string;
  callId?: string;
  /** Solo actividad real del equipo comercial, sin eventos del sistema (#1309). */
  team?: boolean;
}

export async function fetchActivities(
  params: ActivitiesListParams = {},
): Promise<ActivitiesPage> {
  const { page = 1, limit = 100, type, leadId, callId, team } = params;
  const res = await api.get("/crm/activitiesList", {
    params: {
      page,
      limit,
      ...(type ? { type } : {}),
      ...(leadId ? { leadId } : {}),
      ...(callId ? { callId } : {}),
      ...(team ? { team: "1" } : {}),
    },
  });
  const body = res.data ?? {};
  return {
    data: Array.isArray(body.data) ? body.data : [],
    totalItems: body.meta?.totalItems ?? 0,
    totalPages: body.meta?.totalPages ?? 1,
    currentPage: body.meta?.currentPage ?? page,
  };
}
